export default __webpack_public_path__ + "static/media/deutz-fahr-m625.6ce29860.jpg";